module.exports = __webpack_public_path__ + "img/coming-soon-bg.bc403019.jpg";